// Small dismissible inline error banner — the in-app replacement for alert()
// in mutation onError handlers, where a full modal would be too heavy.

interface InlineErrorProps {
    message: string
    onDismiss?: () => void
    style?: React.CSSProperties
}

export function InlineError({ message, onDismiss, style }: InlineErrorProps) {
    return (
        <div
            role="alert"
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--space-3)',
                background: 'rgba(239, 68, 68, 0.1)',
                border: '1px solid var(--color-error)',
                color: 'var(--color-error)',
                borderRadius: 'var(--radius-md)',
                padding: 'var(--space-3) var(--space-4)',
                fontSize: 'var(--text-sm)',
                ...style,
            }}
        >
            <span style={{ flex: 1 }}>⚠️ {message}</span>
            {onDismiss && (
                <button
                    onClick={onDismiss}
                    aria-label="Dismiss"
                    style={{
                        background: 'none',
                        border: 'none',
                        color: 'inherit',
                        cursor: 'pointer',
                        fontSize: 'var(--text-base)',
                        lineHeight: 1,
                        padding: 0,
                        flexShrink: 0,
                    }}
                >
                    ✕
                </button>
            )}
        </div>
    )
}
